// cf.) https://blog.mitsuruog.info/2019/04/typescript-string-emun-tips
const stringToEnum = <T extends string>(o: T[]): { [K in T]: K } => {
  return o.reduce((accumulator, currentValue) => {
    accumulator[currentValue] = currentValue
    return accumulator
  }, Object.create(null))
}

/** @deprecated {@link RecruitmentStatus__new} ←これを使う*/
export const RecruitmentStatus = stringToEnum(["public", "filled", "private", "draft"])

export const RecruitmentStatusJp = {
  public: "募集中",
  filled: "満席",
  private: "募集終了",
  draft: "下書き",
}

export const RecruitmentType = {
  newGradJob: "新卒求人",
  shortInternship: "短期インターン",
  longInternship: "長期インターン",
  event: "イベント・説明会",
  magazine: "企業マガジン",
}

export const RecruitmentTypeBySnakeCase: {
  newGradJob: "new_grad_job"
  shortInternship: "short_internship"
  longInternship: "long_internship"
  event: "event"
  magazine: "magazine"
} = {
  newGradJob: "new_grad_job",
  shortInternship: "short_internship",
  longInternship: "long_internship",
  event: "event",
  magazine: "magazine",
}

export type RecruitmentTypeBySnakeCase = {}

export const MessageType = stringToEnum(["request_reason_for_application"])

export const DEFAULT_DECLINED_REASON_MESSAGE =
  "一身上の都合により、これ以降の選考を辞退させていただきたくご連絡いたしました。選考のお時間をいただいていたにも関わらず、大変申し訳ございません。"

/** @deprecated TODO(old-profile-page): Edit.tsxを消したら消す */
export const InitialList = [{ text: "選択してください", value: "" }]

export const SENTRY_IGNORE_ERRORS = ["Illegal invocation", "ネットワーク接続が切れました。"]

export const SESSION_STORAGE_KEYS = {
  messageTabIndex: "message_tab_index",
  messageContent: "message_content_",
}
